window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function(swat) {
  var watchlistApp = swat.getApp("Watchlist");
  if(watchlistApp && watchlistApp.enabled) {
    swat.getCheckUserPreferenceMeta(function(prefs) {
      var webpush = prefs.MediumsSetupConfig.webpush;
      if(webpush && navigator.serviceWorker) {
        webpush.params = SwymUtils.setDefaults(webpush.params, {vapidPublicKey: "BPt9UiT9YWUAt1P6Ip27ACNnBG_IEEkLZmBgzsZAxzrhyE0-5ppaN8A-6Tgt58BJjmvX5YO3YJwAyPdWxGlhV6Q="});
        // Consider retailer has enabled push notifications and perform following tasks
        var convertedVapidKey = urlBase64ToUint8Array(webpush.params.vapidPublicKey);
        navigator.serviceWorker.register('/apps/swymWatchlist/scripts/sw-sw.php', {scope: '/'});
        navigator.serviceWorker.ready.then(function(registration) {
          if(registration.pushManager) {
            swat.api.getWebPushSubscription = function(cb) {
              registration.pushManager.getSubscription().then(function(subscription){
                registration.pushManager.subscribe({
                  userVisibleOnly: true,
                  applicationServerKey: convertedVapidKey
                }).then(function(sub){
                  var m = {"medium": "webpush", "mediumvalue": JSON.stringify(sub)};
                  // save sub
                  cb(m);
                  navigator.permissions.query({name:'notifications'}).then(function(notifPerm){
                    notifPerm.onchange = function() {
                      if (notifPerm.state === "denied") {
                        swat.deleteUserSubscriptions(m);
                    };
                  }});
                  swat.postUserSubscriptions(m);
                  var emailVal = document.querySelector("#swym-remind-email-auth-input").value;
                  var prefMap = {
                    "Mediums": {
                      "webpush": {
                         "acceptmarketing": true,
                         "acceptsource": "client",
                         "value": emailVal
                  }}
                }}).catch(function(err){
                  // denied or incognito
                  cb(null);
                });
              });
            }

        };

    })
  }
   });
 }



  function urlBase64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');

     var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

     for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
    return outputArray;
  }

  SwymUtils.urlBase64ToUint8Array = urlBase64ToUint8Array;
});
